import { create } from 'zustand'
import { ALLOWED, type Capabilities, readCapabilities, sameCapabilities } from '@/features/capabilities/capabilities'
import type { UserSession } from '@/types/models'

// Fed from the /auth/me body inside `loadHome`, not from the stored user object: useAccount spreads
// PUT /profile responses over that user, and one with no block would make disabled features reappear until reload.
// Shaped like flags.store.ts, but per country; an item shows only when both the flag and the country allow it.
interface CapabilitiesState {
  capabilities: Capabilities
  loaded: boolean
  setFromUser: (user: UserSession) => void
  clear: () => void
}

export const useCapabilitiesStore = create<CapabilitiesState>((set, get) => ({
  // Starts permissive: the backend still refuses what the country disallows, so being wrong for a moment
  // costs a refusal, not a feature nobody can find.
  capabilities: ALLOWED,
  loaded: false,
  setFromUser: (user) => {
    const next = readCapabilities(user.capabilities)
    // Only replace the object when the answer changed, so a boot or role switch does not re-render every gated screen.
    if (get().loaded && sameCapabilities(next, get().capabilities)) return
    set({ capabilities: next, loaded: true })
  },
  // Back to permissive on sign-out, so the next person on this browser does not inherit a country.
  clear: () => set({ capabilities: ALLOWED, loaded: false }),
}))
